import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

const DEFAULT_PAGE = 1
const RESULTS_PER_PAGE = 10

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchNewAvailabilities ({ commit }, filters) {
      commit('clearAvailabilities')

      await platformAction({
        client: this.$api.rooms,
        method: 'getAll',
        commit,
        logError: this.$logError,
        params: {
          filter: filters,
          page: DEFAULT_PAGE,
          perPage: RESULTS_PER_PAGE
        },
        include: ['room', 'hotel', 'hotel.venue', 'availability_rates', 'default_availability_rate']
      })
    },
    async fetchNewAvailability ({ commit }, id) {
      await platformAction({
        client: this.$api.rooms,
        method: 'get',
        commit,
        logError: this.$logError,
        params: id,
        include: ['room', 'hotel', 'hotel.venue', 'availability_rates', 'availability_rates.availability', 'availability_rates.rate_plan', 'default_availability_rate']
      })
    },
    async fetchMoreAvailabilities ({ commit, getters }, filters) {
      if (getters.currentPage < getters.totalPages) {
        await platformAction({
          client: this.$api.rooms,
          method: 'getAll',
          commit,
          logError: this.$logError,
          params: {
            filter: filters,
            page: getters.currentPage + 1,
            perPage: RESULTS_PER_PAGE
          }
        })
      }
    }
  },
  getters: {
    ...platformGetters,
    allResultsFetched: (_, getters) => getters.totalPages <= getters.currentPage
  },
  mutations: {
    ...platformMutations,
    clearAvailabilities (s) {
      s.data = {}
    }
  }
}
